import React from "react";
import Logo from "@/src/components/layout/Logo";
import BrandIcon from "@/src/shared/components/icons/BrandIcon";

type SocialIcon = {
  /** The link's accessible name: the icon alone says nothing to a screen reader. */
  name: string;
  icon: React.ReactNode;
  link: string;
};

const socialLinks: SocialIcon[] = [
  {
    name: "Travela on Facebook",
    icon: <BrandIcon name="facebookF" />,
    link: "https://www.facebook.com/travelaxyz",
  },
  {
    name: "Travela on Instagram",
    icon: <BrandIcon name="instagram" />,
    link: "https://www.instagram.com/travelahomes",
  },
  {
    name: "Travela on TikTok",
    icon: <BrandIcon name="tiktok" />,
    link: "https://www.tiktok.com/@travela.xyz",
  },
  {
    name: "Travela on LinkedIn",
    icon: <BrandIcon name="linkedinIn" />,
    link: "https://www.linkedin.com/company/travelaplatform",
  },
  {
    name: "Travela on YouTube",
    icon: <BrandIcon name="youtube" />,
    link: "https://www.youtube.com/@travelaplatformltd.6849",
  },
];

const iconStyle =
  "w-[20px] h-[20px] relative top-[2.24px] left-[2px] text-white";

const LogoAndSocial: React.FC = () => (
  <div>
    <div className="flex items-center mb-4">
      <Logo />
    </div>
    <p className="text-ink-secondary mb-6 text-sm">
      Wherever you go, there is always a place for you.
    </p>
    <div className="flex space-x-4">
      {socialLinks.map(({ name, icon, link }) => (
        <a
          key={link}
          href={link}
          aria-label={name}
          target="_blank"
          rel="noopener noreferrer"
          className="w-8 h-8 bg-black rounded-full flex items-center justify-center hover:bg-gray-800"
        >
          <span className={iconStyle} aria-hidden>
            {icon}
          </span>
        </a>
      ))}
    </div>
  </div>
);

export default LogoAndSocial;
